import { type LoaderFunction } from 'react-router';
import {
  getFollowUpPageData,
  initializeFollowUpPage,
} from './followUpLoaderHelper';

const followUpConfirmPageLoader: LoaderFunction = () => {
  const pageData = getFollowUpPageData();
  // TODO: Redirect to timeslots if no matching follow-up slot is selected once follow-up context can be restored.
  initializeFollowUpPage(pageData, 'followup-confirm');
  return pageData;
};

export default followUpConfirmPageLoader;
